import { ReactComponent as DesktopIcon } from "../../../assets/images/icons/desktop-icon.svg";
import { ReactComponent as ChatIcon } from "../../../assets/images/icons/chat-icon.svg";
import { ReactComponent as CallIcon } from "../../../assets/images/icons/zeppelin-call-icon.svg";

import { links, envs } from "../../../config";

const chatPopUpProps = {
  height: 600,
  width: 500,
  status: "yes",
  fullscreen: "no",
  toolbar: "no",
  menubar: "no",
  location: "no",
};

export const chatLinks = {
  habitacional: {
    sinistro: "573U50000000lOj",
    servico: "573Dn000000ttcj",
    assistencia: "573U50000000lQL",
  },
  residencial: {
    sinistro: "573U50000000lTZ",
    servico: "573Dn000000ttcF",
    assistencia: "573U50000000lRx",
  },
  empresarial: {
    sinistro: "573U50000000lWn",
    servico: "573U50000000lVB",
    assistencia: "573U50000000lYP",
  },
};

export const chatLink = (chatId) => ({
  icon: ChatIcon,
  title: "Abrir chat",
  onClick: () => {
    window.open(
      `${envs.hostAtendimentoChat}/LiveAgentChatRouting?button_id=${chatId}`,
      null,
      Object.keys(chatPopUpProps)
        .map((key) => `${key}=${chatPopUpProps[key]}`)
        .join(", ")
    );
  },
});

export const callLink = {
  icon: CallIcon,
  title: "0800 274 1000",
  description: "De segunda a sexta, das 8h às 19h, exceto feriados nacionais.",
  href: "tel:0800 274 1000",
};

export const clientAccess = {
  icon: DesktopIcon,
  title: "Acessar área do cliente",
  description: "Consulte informações sobre o seu seguro a qualquer momento.",
  href: links.areaLogada,
};
